import React, { useEffect } from 'react';
import { IntegrityForm } from 'features/settings/integrityManagement/helpers/integrityManagement.constants';
import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';
import { Grid } from '@material-ui/core';
import { useFormikContext, Field } from 'formik';
import withStyles from '@material-ui/styles/withStyles';
import { debounce } from 'lodash';
import { useMemo } from 'react';

const GeographyRuleDataFormComponent = ({
  updateValue,
  integrity,
  classes,
}) => {
  const { values } = useFormikContext();

  const debouncedUpdateValue = useMemo(() => {
    return debounce((newValues) => {
      updateValue(newValues);
    }, 500);
  }, [updateValue]);

  useEffect(() => {
    let checkValue = {};
    if (integrity && integrity.value) {
      checkValue = { x: integrity.value.x, y: integrity.value.y };
    }

    if (values.value !== checkValue) {
      debouncedUpdateValue(values.value);
    }

    // eslint-disable-next-line
  }, [values]);

  return (
    <Grid className={classes.gridStyle}>
      <Grid item xs={6} container>
        <Field
          type="number"
          placeholder="Latitude"
          component={TextFieldFormik}
          name={`${IntegrityForm.VALUE}.x`}
          className={classes.fieldStyle}
        />
      </Grid>
      <Grid item xs={6} container>
        <Field
          type="number"
          placeholder="Longitude"
          component={TextFieldFormik}
          name={`${IntegrityForm.VALUE}.y`}
        />
      </Grid>
    </Grid>
  );
};

const styles = (theme) => ({
  gridStyle: {
    display: 'flex',
  },
  fieldStyle: {
    marginRight: theme.spacing(0.5),
  },
});

export default withStyles(styles)(GeographyRuleDataFormComponent);
